//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WebCodeSearch from 'src/components/WebCodeSearch';
import Filters from 'src/components/Filters';
import VueRecaptcha from 'vue-recaptcha';
import { debounce } from 'lodash';
import Vue from 'vue';
export default {
  name: 'Layout',
  data: function data() {
    return {
      tab: 'home',
      leftDrawerOpen: false,
      miniState: false,
      showSearch: false,
      recaptchaKey: process.env.RECAPTCHA_SITE_KEY,
      showFilteredUpdateMeDialog: false,
      showFilters: false,
      filters: {
        type: null,
        contract: 'sale',
        from_price: 0,
        to_price: 0,
        from_area: 0,
        to_area: 0,
        attic: false,
        detached: false,
        has_garden: false,
        bathrooms: null,
        rooms: null,
        delivery: null,
        company_id: null,
        city_ids: [],
        typology_category_ids: []
      },
      updateEmail: '',
      agreeToTerms: false,
      recaptchaCode: '',
      issueEmail: '',
      issueText: '',
      loading: true,
      contactEmail: null,
      foundConstructionsCount: 0
    };
  },
  components: {
    WebCodeSearch: WebCodeSearch,
    Filters: Filters,
    VueRecaptcha: VueRecaptcha
  },
  computed: {
    viewName: function viewName() {
      return this.$store.state.app.viewName;
    }
  },
  watch: {
    'showFilteredUpdateMeDialog': debounce(function () {
      this.getMatchingConstructions();
    }, 500),
    'filters': {
      deep: true,
      handler: debounce(function () {
        this.getMatchingConstructions();
      }, 500)
    }
  },
  methods: {
    addGuestToFilteredUpdateList: function addGuestToFilteredUpdateList() {
      var _this = this;
      this.$q.dialog({
        title: 'Conferma email',
        message: 'Verifica se il tuo indirizzo email "' + this.updateEmail + '" è corretto.',
        cancel: {
          label: 'Annulla',
          color: 'negative'
        },
        ok: {
          label: 'Conferma',
          color: 'primary'
        },
        persistent: true
      }).onOk(function () {
        _this.$q.loading.show();
        Vue.prototype.$axios.post("/api/construction-subscriptions", {
          filters: _this.filters,
          email: _this.updateEmail,
          recaptcha: _this.recaptchaCode
        }).then(function (response) {
          _this.$q.loading.hide();
          _this.$q.notify({
            type: 'positive',
            message: _this.$t('Iscrizione avvenuta con successo!')
          });
          _this.updateEmail = '';
          _this.showFilteredUpdateMeDialog = false;
          _this.agreeToTerms = false;
          _this.recaptchaCode = '';
        }).catch(function (e) {
          _this.$q.loading.hide();
        });
      });
    },
    getMatchingConstructions: function getMatchingConstructions() {
      var _this2 = this;
      this.foundConstructionsCount = undefined;
      Vue.prototype.$axios.post("/api/constructions-count", this.filters).then(function (response) {
        _this2.foundConstructionsCount = response.data;
      }).catch(function (e) {
        _this2.foundConstructionsCount = 0;
      });
    },
    toggleLeftDrawer: function toggleLeftDrawer() {
      this.leftDrawerOpen = !this.leftDrawerOpen;
    },
    logout: function logout() {
      // localStorage.removeItem('access_token')
      this.$router.push('/login');
    },
    onVerifyRecaptcha: function onVerifyRecaptcha(response) {
      this.recaptchaCode = response;
    },
    onRecaptchaExpired: function onRecaptchaExpired() {
      this.recaptchaVerified = true;
      this.$refs.recaptcha.reset();
    },
    showPrivacyDialog: function showPrivacyDialog() {
      window.open('/statics/legal/informativa_privacy.html', '_blank');
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    this.$root.$on('showFilteredUpdateMeDialog', function () {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this3.showFilteredUpdateMeDialog = show;
    });
  }
};